import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AuthCallback from './auth/AuthCallback';
import CompletionApp from './CompletionApp';
import { AUTH_CONFIG } from '../config';

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        {/* Main completion app */}
        <Route path="/" element={<CompletionApp />} />

        {/* Auth callback - only if auth is enabled */}
        {AUTH_CONFIG.ENABLED && (
          <Route path="/auth/callback" element={<AuthCallback />} />
        )}

        {/* Fallback to main app for unknown routes */}
        <Route path="*" element={<CompletionApp />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;